import RadioGroup from '@mui/material/RadioGroup';
import styled from 'styled-components';
export const RadioGroupStyled = styled(RadioGroup)(({ theme, }) => ({
// Add styles here
}));
//# sourceMappingURL=RadioGroup.styles.js.map